import throttle from '../utils/throttle';

export default () => {
  const $header = $('.header-page');

  const makeFixedHeader = () => {
    if ($(window).scrollTop() > 50) {
      $header.addClass('header-page--active');
    } else {
      $header.removeClass('header-page--active');
    }
  };

  makeFixedHeader();
  $(window).on('scroll', throttle(() => {
    makeFixedHeader();
  }, 100));
};
